module.exports = __webpack_public_path__ + "frontStatic/img/wxScan.225cb29a.png";